/**
 * stationTheme.js — derives a visual accent color from a station's genre so
 * each station feels distinct in the workspace switcher and identity card.
 *
 * Used by `WorkspaceCard` (sidebar) and the top-bar workspace pill.
 * Keep this lightweight — no Tailwind class generation, just hex + label.
 */
const GENRE_THEMES = [
  { match: /reggae|dancehall|riddim/i,            hex: "#10b981", label: "Reggae"     },
  { match: /disco|dance|edm|house|techno|club/i,  hex: "#fbbf24", label: "Disco/Dance"},
  { match: /silky|smooth|jazz|r&b|rnb|soul|neo/i, hex: "#a855f7", label: "Smooth/R&B" },
  { match: /hip-?hop|trap|rap|urban/i,            hex: "#f43f5e", label: "Hip-Hop"   },
  { match: /pop|top.*40|chart|hits/i,             hex: "#22d3ee", label: "Pop"       },
  { match: /rock|metal|alt|indie/i,               hex: "#ef4444", label: "Rock"      },
  { match: /country|americana|folk/i,             hex: "#f97316", label: "Country"   },
  { match: /gospel|worship|christian/i,           hex: "#eab308", label: "Gospel"    },
  { match: /latin|salsa|reggaeton|bachata/i,      hex: "#ec4899", label: "Latin"     },
  { match: /caribbean|soca|calypso|island/i,      hex: "#06b6d4", label: "Caribbean" },
  { match: /talk|news|sports|podcast/i,           hex: "#94a3b8", label: "Talk/News" },
];

const FALLBACK = { hex: "#f59e0b", label: "Broadcast" }; // brand-amber default

/**
 * Derive a visual theme from a station's genre string.
 * Returns { hex, label, ringStyle, glowStyle, tintStyle }.
 * Inline styles are used so we can support arbitrary hex colors without
 * Tailwind JIT pre-compilation.
 */
export function getStationTheme(genre) {
  const raw = (genre || "").trim();
  const match = GENRE_THEMES.find((g) => g.match.test(raw)) || FALLBACK;
  return {
    hex: match.hex,
    label: match.label,
    ringStyle:   { boxShadow: `0 0 0 2px ${match.hex}22` },
    glowStyle:   { boxShadow: `0 8px 28px -8px ${match.hex}80` },
    tintStyle:   { backgroundColor: `${match.hex}1a` /* 10% opacity */ },
    borderStyle: { borderColor: `${match.hex}66` /* 40% opacity */ },
    dotStyle:    { backgroundColor: match.hex },
    barStyle:    { background: `linear-gradient(90deg, ${match.hex} 0%, ${match.hex}33 100%)` },
  };
}
